import {
  CALENDAR_WEEK_NUMBER_CLASS_MAP,
  type TCalendarWeekNumberProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { cn } from "@/ui/lib/utils";

export const CalendarWeekNumber = ({
  children,
  className,
  week: _week,
  ...props
}: TCalendarWeekNumberProps) => (
  <th
    {...props}
    data-component="CalendarWeekNumber"
    className={cn(CALENDAR_WEEK_NUMBER_CLASS_MAP.cell, className)}
  >
    <div className={CALENDAR_WEEK_NUMBER_CLASS_MAP.content}>
      { children }
    </div>
  </th>
);

CalendarWeekNumber.displayName = "CalendarWeekNumber";
